import ApiService from "../../../../services/ApiService";

export const fetchUserAdvancements = (userId: number, setAdvancements: Function, setLoading: Function) => {
  setLoading(true);
  ApiService.get(`users/${userId}/cohorts/advancements`)
    .then((response) => setAdvancements(response.data.cohorts_advancements))
    .catch((error) => console.error("An error occurred while fetching user's cohort advancements", error))
    .finally(() => setLoading(false));
};
